import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast, Toaster } from "sonner";
import BrandLogo from "../components/BrandLogo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("admin@crm.it");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={location.state?.from?.pathname || "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Accesso effettuato");
      navigate(location.state?.from?.pathname || "/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <Toaster position="top-right" richColors />
      {/* Left - form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-10">
            <BrandLogo size={44} />
            <div>
              <div className="font-extrabold text-lg" style={{ fontFamily: "Manrope" }}>
                Nureal<span style={{ color: "#FB8C00" }}>·</span>Operation
              </div>
              <div className="text-xs" style={{ color: "var(--text-muted)" }}>CRM Fotovoltaico · multi-commessa</div>
            </div>
          </div>

          <h1 className="text-3xl font-extrabold tracking-tight mb-2" style={{ fontFamily: "Manrope" }}>
            Bentornato
          </h1>
          <p className="text-sm mb-8" style={{ color: "var(--text-muted)" }}>
            Accedi al tuo pannello gestionale
          </p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 w-full rounded-md border px-3 py-2.5 text-sm outline-none focus:ring-2"
                style={{ borderColor: "var(--border)", background: "#fff" }}
                placeholder="nome@azienda.it"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>Password</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 w-full rounded-md border px-3 py-2.5 text-sm outline-none focus:ring-2"
                style={{ borderColor: "var(--border)", background: "#fff" }}
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-2.5"
              data-testid="login-submit"
            >
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Accesso…</> : "Accedi"}
            </button>
          </form>
        </div>
      </div>

      {/* Right - image panel */}
      <div
        className="hidden lg:block flex-1 relative"
        style={{
          background: `linear-gradient(135deg, rgba(44,85,48,0.85), rgba(31,61,34,0.9)), url('https://images.unsplash.com/photo-1660330589782-83776f89dd1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx0ZWNobmljaWFuJTIwaW5zdGFsbGluZyUyMHNvbGFyfGVufDB8fHx8MTc3NjkzNjg1Mnww&ixlib=rb-4.1.0&q=85') center/cover`,
        }}
      >
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <div className="text-xs font-semibold uppercase tracking-widest opacity-80 mb-3">Progetta • Documenta • Consegna</div>
          <h2 className="text-4xl font-extrabold leading-tight max-w-md" style={{ fontFamily: "Manrope" }}>
            Il gestionale degli installatori fotovoltaici italiani.
          </h2>
          <p className="mt-4 max-w-md text-white/85 text-sm leading-relaxed">
            Sopralluoghi, installazioni, magazzino, materiali, PDF e landing cliente.
            Tutto in un unico flusso chiaro e ordinato.
          </p>
        </div>
      </div>
    </div>
  );
}
